import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchSubmittedAbstractsDetails } from 'store/slices';

export const templateInitialValues = {
  'Session name inclusion notification': {
    client_name: '',
    conference_name: '',
    conference_short_name: '',
    conference_organizer: '',
    // conference_date: '',
    conference_from_date: '',
    conference_to_date: '',
    conference_location: '',
    session_title: '',
    brief_overview: '',
    paper_title: '',
    relevant_field: '',
    specific_sdg_goal_numbers: '',
    your_name: '',
    contact_details: '',
    // view_session_details: '',
    // support_email: '',
    // your_organization_name: '',
    // your_contact_information: '',
    // your_website: '',
  },
  'Coupon or Voucher follow ups/early bird deadline': {
    client_name: '',
    conference_name: '',
    conference_short_name: '',
    // conference_date: '',
    conference_from_date: '',
    conference_to_date: '',
    conference_location: '',
    paper_title: '',
    coupon_code: '',
    registration_link: '',
    your_name: '',
    contact_details: '',
    // discount_amount: '',
    // expiration_date: '',
    // register_now: '',
    // support_email: '',
    // your_name: '',
    // your_title: '',
    // your_contact_information: '',
    // your_website: '',
  },
  'Publication Details Few slots left': {
    client_name: '',
    conference_name: '',
    conference_short_name: '',
    // conference_date: '',
    conference_from_date: '',
    conference_to_date: '',
    conference_location: '',
    registration_link: '',
    paper_title: '',
    journals: [
      {
        journal_name: '',
      },
    ],
    isbn_number: '',
    your_name: '',
    contact_details: '',
    // your_name: '',
    // your_title: '',
    // your_contact_information: '',
    // your_website: '',
  },
  'Session-Based Publication Opportunities and Conference Outcomes at [Conference Name]':
    {
      client_name: '',
      conference_name: '',
      conference_short_name: '',
      conference_date: '',
      conference_location: '',
      paper_title: '',
      sdg_name_number: '',
      sdg_brif_explanation: '',
      registration_link: '',
      your_name: '',
      contact_details: '',
      // your_title: '',
      // your_contact_information: '',
      // your_website: '',
    },
  'Keynote speaker, session speaker notification': {
    client_name: '',
    conference_name: '',
    conference_short_name: '',
    conference_date: '',
    conference_location: '',
    featured_speakers: [
      {
        speaker_name: '',
        speaker_credentials: '',
        speaker_achievements: '',
        speaker_sessionTopic: '',
      },
    ],
    registration_link: '',
    // pre_conference_speaker_name: '',
    // date_time: '',
    // register_webinar: '',
    // view_speaker_profile: '',
    // register_conference: '',
    // your_name: '',
    // your_title: '',
    // your_contact_information: '',
    // your_website: '',
  },
  'Agenda Page and Slot Allotment notification': {
    client_name: '',
    conference_name: '',
    conference_short_name: '',
    venue_name: '',
    address: '',
    map_link: '',
    zoom_link: '',
    registration_date_time: '',
    conference_from_date: '',
    conference_to_date: '',
    conference_location: '',
    hall_ticket_link: '',
    your_name: '',
    contact_details: '',
    paper_titleL: '',
  },
  'Hall Ticket, Zoom link and Confirmation': {
    client_name: '',
    conference_name: '',
    conference_short_name: '',
    conference_location: '',
    venue_name: '',
    full_address: '',
    map_link: '',
    zoom_link: '',
    download_zoom: '',
    registration_venue_name: '',
    registration_street_address: '',
    registration_date_time: '',
    conference_from_date: '',
    conference_to_date: '',
    hall_ticket_link: '',
    support_email: '',
    support_phone: '',
  },
  'Full Paper Follow-Up Email': {
    client_name: '',
    conference_name: '',
    conference_short_name: '',
    conference_from_date: '',
    conference_to_date: '',
    conference_location: '',
    submission_date_line: '',
    guideline: '',
    submission_full_paper: '',
    contact_support: '',
    your_name: '',
    your_title: '',
    your_contact_information: '',
    your_website: '',
  },
  'Conference testimonials email with CPD': {
    client_name: '',
    conference_name: '',
    conference_short_name: '',
    register_link: '',
    video_link: '',
    your_name: '',
    contact_details: '',
  },
  'Scope of the Research Notification': {
    client_name: '',
    conference_name: '',
    conference_short_name: '',
    registration_link: '',
    // video_link: '',
    conference_location: '',
    paper_title: '',
    conference_from_date: '',
    conference_to_date: '',
    specific_topic: '',
    specific_field: '',
    your_name: '',
    contact_details: '',
  },
  'Coupon or Voucher follow ups/early bird deadline - Set 2': {
    client_name: '',
    conference_name: '',
    conference_short_name: '',
    // conference_date: resData?.conference_date || '',
    conference_location: '',
    paper_title: '',
    conference_from_date: '',
    conference_to_date: '',
    coupon_code: '',
    discount_amount: '',
    registration_link: '',
    your_name: '',
    contact_details: '',
  },
  'Coupon or Voucher follow ups/early bird deadline - Set 3': {
    client_name: '',
    conference_name: '',
    conference_short_name: '',
    registration_link: '',
    conference_from_date: '',
    conference_to_date: '',
    deadline_date: '',
    your_name: '',
    contact_details: '',
  },
  'Allotment of ISBN and ISSN Number': {
    client_name: '',
    conference_name: '',
    conference_short_name: '',
    conference_from_date: '',
    conference_to_date: '',
    registration_link: '',
    your_name: '',
    contact_details: '',
  },
  'Visa-Free Projection': {
    client_name: '',
    conference_name: '',
    conference_short_name: '',
    country_name: '',
    visa_free_guide_link: '',
    registration_link: '',
    your_name: '',
    contact_details: '',
  },
  'Scholarships & Awards Notification': {
    client_name: '',
    conference_name: '',
    conference_short_name: '',
    deadline_date: '',
    conference_from_date: '',
    conference_to_date: '',
    scholarship_link: '',
    your_name: '',
    contact_details: '',
  },
  'Pre-Conference Webinar Announcement': {
    client_name: '',
    speaker_name: '',
    webinar_date_time: '',
    relevent_field_topic: '',
    conference_name: '',
    conference_short_name: '',
    registration_link: '',
  },
  'Refer Your Colleagues': {
    client_name: '',
    conference_short_name: '',
    registration_link: '',
    your_name: '',
    contact_details: '',
  },
  'Awards sales Follow up': {
    client_name: '',
    conference_short_name: '',
    registration_link: '',
    deadline_date: '',
    conference_from_date: '',
    conference_to_date: '',
    your_name: '',
    contact_details: '',
  },
  'Proceedings book Sales Follow up': {
    client_name: '',
    conference_short_name: '',
    registration_link: '',
    your_name: '',
    contact_details: '',
  },
  'Agenda Sales Follow up': {
    client_name: '',
    conference_short_name: '',
    registration_link: '',
    your_name: '',
    contact_details: '',
  },
  'Final Thank You Email for unregistered participants': {
    client_name: '',
    conference_short_name: '',
    photo_access_link: '',
    upcoming_conference_link: '',
    your_name: '',
    contact_details: '',
  },
};

export const usePrefilledInitialsValues = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const [initialValues, setInitialValues] = useState({});

  const getPaperDetails = async () => {
    const response = await dispatch(
      fetchSubmittedAbstractsDetails(params?.paperId)
    );
    const resData = response?.data || null;
    const isLatestPaper = resData?.latest_paper_title
      ? resData?.latest_paper_title
      : '';
      
// console.log('✌️resData --->', resData);
    const filledValues = {
      'Session name inclusion notification': {
        client_name: resData?.authorName || '',
        conference_name: resData?.conference || '',
        conference_short_name: resData?.conference_short_name || '',
        conference_organizer: resData?.organizer_name || '',
        // conference_date: resData?.conference_date || '',
        conference_from_date: resData?.conference_date || '',
        conference_to_date: resData?.conference_to_date || '',
        conference_location: resData?.event_location || '',
        session_title: '',
        brief_overview: '',
        paper_title: isLatestPaper
          ? resData?.latest_paper_title
          : resData?.paperTitle || '',
        relevant_field: '',
        specific_sdg_goal_numbers: '',
        your_name: '',
        contact_details: '',
        // view_session_details: '',
        // support_email: "",
        // your_organization_name: '',
        // your_contact_information: '',
        // your_website: '',
      },
      'Coupon or Voucher follow ups/early bird deadline': {
        client_name: resData?.authorName || '',
        conference_name: resData?.conference || '',
        conference_short_name: resData?.conference_short_name || '',
        // conference_date: resData?.conference_date || '',
        conference_from_date: resData?.conference_date || '',
        conference_to_date: resData?.conference_to_date || '',
        conference_location: resData?.event_location || '',
        paper_title: isLatestPaper
          ? resData?.latest_paper_title
          : resData?.paperTitle || '',
        coupon_code: '',
        registration_link: '',
        your_name: '',
        contact_details: '',
        // discount_amount: '',
        // expiration_date: '',
        // register_now: '',
        // support_email: "",
        // your_name: '',
        // your_title: "",
        // your_contact_information: "",
        // your_website: "",
      },
      'Publication Details Few slots left': {
        client_name: resData?.authorName || '',
        conference_name: resData?.conference || '',
        conference_short_name: resData?.conference_short_name || '',
        // conference_date: resData?.conference_date || '',
        conference_from_date: resData?.conference_date || '',
        conference_to_date: resData?.conference_to_date || '',
        conference_location: resData?.event_location || '',
        registration_link: '',
        paper_title: isLatestPaper
          ? resData?.latest_paper_title
          : resData?.paperTitle || '',
        journals: [
          {
            journal_name: '',
          },
        ],
        isbn_number: '',
        your_name: '',
        contact_details: '',
        // your_name: '',
        // your_title: '',
        // your_contact_information: '',
        // your_website: '',
      },
      'Session-Based Publication Opportunities and Conference Outcomes at [Conference Name]':
        {
          client_name: resData?.authorName || '',
          conference_name: resData?.conference || '',
          conference_short_name: resData?.conference_short_name || '',
          // conference_date: resData?.conference_date || '',
          conference_from_date: resData?.conference_date || '',
          conference_to_date: resData?.conference_to_date || '',
          conference_location: resData?.event_location || '',
          paper_title: isLatestPaper
            ? resData?.latest_paper_title
            : resData?.paperTitle || '',
          sdg_name_number: '',
          sdg_brif_explanation: '',
          registration_link: '',
          your_name: '',
          contact_details: '',
          // your_title: "",
          // your_contact_information: "",
          // your_website: "",
        },
      'Keynote speaker, session speaker notification': {
        client_name: resData?.authorName || '',
        conference_name: resData?.conference || '',
        conference_short_name: resData?.conference_short_name || '',
        conference_date: resData?.conference_date || '',
        conference_location: resData?.event_location || '',
        featured_speakers: [
          {
            speaker_name: '',
            speaker_credentials: '',
            speaker_achievements: '',
            speaker_sessionTopic: '',
          },
        ],
        registration_link: '',
        // pre_conference_speaker_name: '',
        // date_time: '',
        // register_webinar: '',
        // view_speaker_profile: '',
        // register_conference: '',
        // your_name: '',
        // your_title: '',
        // your_contact_information: '',
        // your_website: '',
      },
      'Agenda Page and Slot Allotment notification': {
        client_name: resData?.authorName || '',
        conference_name: resData?.conference || '',
        conference_short_name: resData?.conference_short_name || '',
        venue_name: '',
        address: '',
        map_link: '',
        zoom_link: '',
        registration_date_time: '',
        conference_from_date: resData?.conference_date || '',
        conference_to_date: resData?.conference_to_date || '',
        conference_location: resData?.event_location || '',
        hall_ticket_link: '',
        your_name: '',
        contact_details: '',
        paper_title: isLatestPaper
          ? resData?.latest_paper_title
          : resData?.paperTitle || '',
      },
      'Hall Ticket, Zoom link and Confirmation': {
        client_name: resData?.authorName || '',
        conference_name: resData?.conference || '',
        conference_short_name: resData?.conference_short_name || '',
        conference_location: resData?.event_location || '',
        venue_name: '',
        full_address: '',
        map_link: '',
        zoom_link: '',
        download_zoom: '',
        registration_venue_name: '',
        registration_street_address: '',
        registration_date_time: '',
        conference_from_date: resData?.conference_date || '',
        conference_to_date: resData?.conference_to_date || '',
        hall_ticket_link: '',
        support_email: '',
        support_phone: '',
      },
      'Full Paper Follow-Up Email': {
        client_name: resData?.authorName || '',
        conference_name: resData?.conference || '',
        conference_short_name: resData?.conference_short_name || '',
        conference_from_date: resData?.conference_date || '',
        conference_to_date: resData?.conference_to_date || '',
        conference_date: resData?.conference_date || '',
        conference_location: resData?.event_location || '',
        paper_title: isLatestPaper
          ? resData?.latest_paper_title
          : resData?.paperTitle || '',
        submission_date_line: '',
        guideline: '',
        submission_full_paper: '',
        contact_support: '',
        your_name: '',
        your_title: '',
        your_contact_information: '',
        your_website: '',
      },
      'Conference testimonials email with CPD': {
        client_name: resData?.authorName || '',
        conference_name: resData?.conference || '',
        conference_short_name: resData?.conference_short_name || '',
        register_link: '',
        video_link: '',
        your_name: '',
        contact_details: '',
      },
      'Scope of the Research Notification': {
        client_name: resData?.authorName || '',
        conference_name: resData?.conference || '',
        conference_short_name: resData?.conference_short_name || '',
        registration_link: '',
        conference_location: resData?.event_location || '',
        paper_title: isLatestPaper
          ? resData?.latest_paper_title
          : resData?.paperTitle || '',
        conference_from_date: resData?.conference_date || '',
        conference_to_date: resData?.conference_to_date || '',
        specific_topic: '',
        specific_field: '',
        your_name: '',
        contact_details: '',
      },
      'Coupon or Voucher follow ups/early bird deadline - Set 2': {
        client_name: resData?.authorName || '',
        conference_name: resData?.conference || '',
        conference_short_name: resData?.conference_short_name || '',
        // conference_date: resData?.conference_date || '',
        conference_location: resData?.event_location || '',
        paper_title: isLatestPaper
          ? resData?.latest_paper_title
          : resData?.paperTitle || '',
        conference_from_date: resData?.conference_date || '',
        conference_to_date: resData?.conference_to_date || '',
        coupon_code: '',
        discount_amount: '',
        registration_link: '',
        your_name: '',
        contact_details: '',
      },
      'Coupon or Voucher follow ups/early bird deadline - Set 3': {
        client_name: resData?.authorName || '',
        conference_name: resData?.conference || '',
        conference_short_name: resData?.conference_short_name || '',
        registration_link: '',
        conference_from_date: resData?.conference_date || '',
        conference_to_date: resData?.conference_to_date || '',
        deadline_date: '',
        your_name: '',
        contact_details: '',
      },
      'Allotment of ISBN and ISSN Number': {
        client_name: resData?.authorName || '',
        conference_name: resData?.conference || '',
        conference_short_name: resData?.conference_short_name || '',
        conference_from_date: resData?.conference_date || '',
        conference_to_date: resData?.conference_to_date || '',
        registration_link: '',
        your_name: '',
        contact_details: '',
      },
      'Visa-Free Projection': {
        client_name: resData?.authorName || '',
        conference_name: resData?.conference || '',
        conference_short_name: resData?.conference_short_name || '',
        country_name: '',
        visa_free_guide_link: '',
        registration_link: '',
        your_name: '',
        contact_details: '',
      },
      'Scholarships & Awards Notification': {
        client_name: resData?.authorName || '',
        conference_name: resData?.conference || '',
        conference_short_name: resData?.conference_short_name || '',
        deadline_date: '',
        conference_from_date: resData?.conference_date || '',
        conference_to_date: resData?.conference_to_date || '',
        scholarship_link: '',
        your_name: '',
        contact_details: '',
      },
      'Pre-Conference Webinar Announcement': {
        client_name: resData?.authorName || '',
        speaker_name: '',
        webinar_date_time: '',
        relevent_field_topic: '',
        conference_name: resData?.conference || '',
        conference_short_name: resData?.conference_short_name || '',
        registration_link: '',
      },
      'Refer Your Colleagues': {
        client_name: resData?.authorName || '',
        conference_short_name: resData?.conference_short_name || '',
        registration_link: '',
        your_name: '',
        contact_details: '',
      },
      'Awards sales Follow up': {
        client_name: resData?.authorName || '',
        conference_short_name: resData?.conference_short_name || '',
        registration_link: '',
        deadline_date: '',
        conference_from_date: resData?.conference_date || '',
        conference_to_date: resData?.conference_to_date || '',
        your_name: '',
        contact_details: '',
      },
      'Proceedings book Sales Follow up': {
        client_name: resData?.authorName || '',
        conference_short_name: resData?.conference_short_name || '',
        registration_link: '',
        your_name: '',
        contact_details: '',
      },
      'Agenda Sales Follow up': {
        client_name: resData?.authorName || '',
        conference_short_name: resData?.conference_short_name || '',
        registration_link: '',
        your_name: '',
        contact_details: '',
      },
      'Final Thank You Email for unregistered participants': {
        client_name: resData?.authorName || '',
        conference_short_name: resData?.conference_short_name || '',
        photo_access_link: '',
        upcoming_conference_link: '',
        your_name: '',
        contact_details: '',
      },
    };
    return filledValues;
  };

  useEffect(() => {
    const fetchValues = async () => {
      if (params?.paperId) {
        const filledValues = await getPaperDetails();
        setInitialValues(filledValues); // Set the fetched values in state
      }
    };

    fetchValues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.paperId]);

  return initialValues;
};
